import React, { useState } from "react";

import { Box } from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import ExpandLessIcon from "@material-ui/icons/ExpandLess";



/**

 * Acordeón del panel Editar.

 * @param {boolean} nested - subapartado (más compacto, para anidar dentro de secciones)

 */

export default function ErEditAccordion({ title, icon: Icon, defaultOpen = false, nested = false, children }) {

	const [open, setOpen] = useState(defaultOpen);

	return (

		<Box

			mb={nested ? 1 : 2}

			borderRadius={nested ? 10 : 12}

			style={{

				border: nested ? "1px solid #e8ecf1" : "1px solid #e2e8f0",

				background: nested ? "#fff" : "#f8fafc",

				width: "100%",

				maxWidth: "100%",

				boxSizing: "border-box",

			}}

		>

			<Box

				role="button"

				tabIndex={0}

				onClick={() => setOpen((v) => !v)}

				onKeyDown={(e) => {

					if (e.key === "Enter" || e.key === " ") {

						e.preventDefault();

						setOpen((v) => !v);

					}

				}}

				display="flex"

				alignItems="center"

				justifyContent="space-between"

				px={nested ? 1.5 : 2}

				py={nested ? 1 : 1.25}

				style={{

					cursor: "pointer",

					gap: 8,

					minWidth: 0,

					background: nested ? "#f1f5f9" : "transparent",

					borderBottom: nested && open ? "1px solid #e8ecf1" : "none",

				}}

			>

				<Box display="flex" alignItems="center" style={{ gap: nested ? 6 : 8, minWidth: 0 }}>

					{Icon && !nested ? <Icon style={{ fontSize: 20, color: "#64748b", flexShrink: 0 }} /> : null}

					<Box

						fontSize={nested ? 12 : 13}

						fontWeight={nested ? 600 : 700}

						color="#334155"

						style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}

					>

						{title}

					</Box>

				</Box>

				{open ? <ExpandLessIcon style={{ color: "#94a3b8", flexShrink: 0, fontSize: nested ? 20 : 24 }} /> : <ExpandMoreIcon style={{ color: "#94a3b8", flexShrink: 0, fontSize: nested ? 20 : 24 }} />}

			</Box>

			{open && (

				<Box

					px={nested ? 1.5 : 2}

					pb={nested ? 2.5 : 2}

					pt={nested ? 2 : 1.5}

					style={{

						width: "100%",

						maxWidth: "100%",

						boxSizing: "border-box",

						display: "flex",

						flexDirection: "column",

						gap: nested ? 10 : 12,

						overflow: "visible",

					}}

				>

					{children}

				</Box>

			)}

		</Box>

	);

}


